var map;
var markers = [];
var infoWindows = [];

google.maps.event.addDomListener( window, 'load', initMap );

function initMap(){
    map = new google.maps.Map(document.getElementById('map'), {
        center: {
            // 二物件あるので物件と物件の間を中心としています
            lat: 34.5544698,
            lng: 135.505691
            // 以下の緯度経度を置換 var markerに同様の緯度経度があるため
            // lat:34.5544413, 
            // lng:135.5060124
        },
        zoom: 17,
        mapTypeControl: false,
        scrollwheel: false,
        streetViewControl: false
    });
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(34.5544413,135.5060124),
        map: map,
        icon: '../images/location/pin/pin_axis.png'
    });
    var marker1 = new google.maps.Marker({
        position: new google.maps.LatLng(34.55366257771953,135.50541981402012),
        map: map,
        icon: '../images/location/pin/pin_bright.png'
    });
    // サンプルのため「shopping」、最初に表示する地図の名前に変更
    setMarker('shopping');
}

$('[data-map-area]').on('click', function(){
    setMarker($(this).data('map-area'));
    return false;
});

$('[data-map]').on('click', function(){
    var target = parseInt($(this).attr('href').slice(7));
    console.log(target);
    for (var i = 0; i < infoWindows.length; i++) {
        infoWindows[i].close();
    }
    infoWindows[target].open(markers[target].getMap(), markers[target]);
    map.panTo(markers[target].getPosition());
    return false;
});

function setMarker(type){
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
    infoWindows = [];
    var data = mapData[type];
    for (var i = 0; i < data.length; i++) {
        var num = i + 1;
        // pinNoを二桁にする
        var pinNo = ('00' + num).slice(-2);
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(data[i]['lat'], data[i]['lng']),
            map: map,
            // iconを編集しない場合はデフォルトです
            // ピンを画像にする場合
            // icon: '../images/location/pin/pin.png'
            // 全て項目のピンが同じ場合
            icon: '../images/location/pin/pin_' + pinNo + '.png'
            // 項目ごとにピンの色を変える場合
            // icon: '../images/location/pin/pin_' + type + '-' + pinNo + '.png'
        });
        var infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
            content: '<div class="u-text-bold">' + data[i]['title'] + '</div>' // 吹き出しに表示する内容
        });
        markers.push(marker);
        infoWindows.push(infoWindow);

        openInfoWindow(marker, infoWindow);
    }
}

function openInfoWindow(marker, infoWindow){
    google.maps.event.addListener(marker, 'click', function (event) {
        for (var i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }
        infoWindow.open(marker.getMap(), marker);
        map.panTo(marker.getPosition());
    });
}


var mapData = {
    'shopping': [
        {
            lat: 34.55460761,
            lng: 135.5029771,
            title: '業務スーパー なかもず店'
        },
        {
            lat: 34.55529864,
            lng: 135.5072953,
            title: 'サンプラザ 中百舌鳥店'
        },
        {
            lat: 34.55310407,
            lng: 135.5034654,
            title: 'デイリーカナート中百舌鳥店'
        },
        {
            lat: 34.55832134,
            lng: 135.5091172,
            title: 'ライフなかもず店'
        },
        {
            lat: 34.5537547,
            lng: 135.5109742,
            title: 'ダイエーグルメシティ 中もず店'
        },
        {
            lat: 34.55396685,
            lng: 135.511136,
            title: 'コーナン中もず店'
        },
        {
            lat: 34.55374597,
            lng: 135.5103206,
            title: 'Seria 中もず店'
        },
        {
            lat: 34.5543108,
            lng: 135.5130751,
            title: '万代 なかもず店'
        },
        {
            lat: 34.55647661,
            lng: 135.505647,
            title: 'ダイコクドラッグ なかもず駅前店'
        },
        {
            lat: 34.55410329,
            lng: 135.5007567,
            title: 'ウエルシア堺百舌鳥梅町店'
        },
        {
            lat: 34.55114971,
            lng: 135.4984301,
            title: 'キリン堂 百舌鳥梅町店'
        },
        {
            lat: 34.558181,
            lng: 135.5092574,
            title: 'エディオン なかもず店'
        },
        {
            lat: 34.5550582,
            lng: 135.5047811,
            title: 'ミニストップ 中百舌鳥駅前店'
        },
        {
            lat: 34.55570074,
            lng: 135.5055697,
            title: 'ローソン なかもず駅東店'
        },
        {
            lat: 34.55599188,
            lng: 135.5035844,
            title: 'セブン-イレブン 堺中百舌鳥駅南口店'
        }
    ],
    'education': [
        {
            lat: 34.5508247,
            lng: 135.5070991,
            title: '堺市立中百舌鳥小学校'
        },
        {
            lat: 34.54931538,
            lng: 135.5096325,
            title: '堺市立中百舌鳥中学校'
        },
        {
            lat: 34.55669426,
            lng: 135.505629,
            title: 'にこにこキッズ中百舌鳥園'
        },
        {
            lat: 34.55688464,
            lng: 135.5055421,
            title: 'なかもずグレイス保育園'
        },
        {
            lat: 34.55207059,
            lng: 135.5027168,
            title: 'Ladybug・インターナショナル・キンダーガーテン'
        },
        {
            lat: 34.55787327,
            lng: 135.503356,
            title: 'ひのまるこども園'
        },
        {
            lat: 34.55351647,
            lng: 135.5010861,
            title: 'ろばのこ保育園'
        },
        {
            lat: 34.55782241,
            lng: 135.5101426,
            title: 'なないろこども園'
        },
        {
            lat: 34.55069686,
            lng: 135.5084751,
            title: 'なかもずこども園'
        },
        {
            lat: 34.55642822,
            lng: 135.4961896,
            title: '未来保育園百舌鳥園'
        }

    ],
    'medical': [
        {
            lat: 34.56797243,
            lng: 135.5095865,
            title: '大阪ろうさい病院'
        },
        {
            lat: 34.56097034,
            lng: 135.5051602,
            title: '小林小児科医院'
        },
        {
            lat: 34.55472721,
            lng: 135.5042858,
            title: '奥田皮膚科医院'
        },
        {
            lat: 34.58127012,
            lng: 135.499804,
            title: 'はやし内科クリニック'
        },
        {
            lat: 34.58038084,
            lng: 135.5052952,
            title: 'おか内科医院'
        },
        {
            lat: 34.55657228,
            lng: 135.5032976,
            title: '岡クリニック'
        },
        {
            lat: 34.55327837,
            lng: 135.5043782,
            title: 'もり耳鼻咽喉科'
        },
        {
            lat: 34.55712562,
            lng: 135.5057923,
            title: 'やまがた呼吸器内科クリニック'
        },
        {
            lat: 34.55624068,
            lng: 135.5031672,
            title: 'かしわぎ眼科'
        },
        {
            lat: 34.56839312,
            lng: 135.507667,
            title: '藤原内科クリニック'
        },
        {
            lat: 34.54932547,
            lng: 135.5022059,
            title: '野崎レディースクリニック'
        },
        {
            lat: 34.55493269,
            lng: 135.5126334,
            title: 'まつお小児科'
        },
        {
            lat: 34.55446834,
            lng: 135.5073524,
            title: '出雲歯科医院'
        },
        {
            lat: 34.55542218,
            lng: 135.5045307,
            title: '奥田歯科医院'
        },
        {
            lat: 34.55386616,
            lng: 135.504359,
            title: '岡歯科医院'
        }
    ],
    'public': [
        {
            lat: 34.56578493,
            lng: 135.5170966,
            title: '堺市北区役所'
        },
        {
            lat: 34.55289718,
            lng: 135.5029066,
            title: '北堺警察署 中百舌鳥交番'
        },
        {
            lat: 34.54908571,
            lng: 135.4994895,
            title: '堺市消防局 北消防署百舌鳥出張所'
        },
        {
            lat: 34.55243845,
            lng: 135.5094841,
            title: '堺中百舌鳥郵便局'
        },
        {
            lat: 34.55360268,
            lng: 135.5045351,
            title: '中百舌鳥町自治公民館'
        },
        {
            lat: 34.56605522,
            lng: 135.5138338,
            title: '大阪府 北堺警察署'
        },
        {
            lat: 34.56611721,
            lng: 135.5169969,
            title: '堺市立北図書館'
        }

    ],
    'financial': [
        {
            lat: 34.55252498,
            lng: 135.5038719,
            title: '紀陽銀行中もず支店'
        },
        {
            lat: 34.55687235,
            lng: 135.5050789,
            title: '関西みらい銀行中もず支店'
        },
        {
            lat: 34.5575075,
            lng: 135.5042829,
            title: '三菱UFJ銀行なかもず駅前ATMコーナー'
        },
        {
            lat: 34.55428267,
            lng: 135.5102175,
            title: '三菱UFJ銀行中もず支店'
        },
        {
            lat: 34.5525867,
            lng: 135.5005629,
            title: '三井住友銀行中もず支店'
        },
        {
            lat: 34.55250086,
            lng: 135.5003116,
            title: '三井住友銀行百舌鳥梅町出張所'
        },
        {
            lat: 34.54976842,
            lng: 135.5141624,
            title: '池田泉州銀行白鷺支店'
        },
        {
            lat: 34.55580684,
            lng: 135.4976716,
            title: '池田泉州銀行もず支店'
        },
        {
            lat: 34.55695102,
            lng: 135.4957536,
            title: '大阪信用金庫もず出張所'
        }
    ],
    'park': [
        {
            lat: 34.55568489,
            lng: 135.5036557,
            title: '中もず5丁公園'
        },
        {
            lat: 34.58876622,
            lng: 135.5096096,
            title: '金口公園'
        },
        {
            lat: 34.55607689,
            lng: 135.5078615,
            title: '中百舌鳥町オレガノ公園'
        },
        {
            lat: 34.55548606,
            lng: 135.5087664,
            title: '中百舌鳥町マジョラム公園'
        },
        {
            lat: 34.5533805,
            lng: 135.5072433,
            title: '中百舌鳥町あずまぎく広場'
        },
        {
            lat: 34.5522665,
            lng: 135.5069052,
            title: '中百舌鳥町みんみんぜみ公園'
        },
        {
            lat: 34.55058118,
            lng: 135.5019549,
            title: '梅町公園'
        },
        {
            lat: 34.55297034,
            lng: 135.5000029,
            title: '城の山公園'
        },
        {
            lat: 34.557713,
            lng: 135.4992152,
            title: '梅寿公園'
        },
        {
            lat: 34.54746083,
            lng: 135.5130311,
            title: '白鷺公園'
        },
        {
            lat: 34.55871537,
            lng: 135.4828173,
            title: '大仙公園'
        },
        {
            lat: 34.57155841,
            lng: 135.5079514,
            title: '金岡公園'
        },
        {
            lat: 34.56509275,
            lng: 135.5275922,
            title: '大泉緑地'
        }

    ],
    'leisure': [
        {
            lat: 34.56413695,
            lng: 135.4874442,
            title: '仁徳天皇陵古墳（大仙古墳）'
        },
        {
            lat: 34.54713941,
            lng: 135.4986326,
            title: 'ニサンザイ古墳'
        },
        {
            lat: 34.55596732,
            lng: 135.5044454,
            title: 'chocoZAP 中百舌鳥'
        },
        {
            lat: 34.55430448,
            lng: 135.4947061,
            title: '百舌鳥八幡宮'
        }
    ]
    
    
}